export const languageOptions = [
  { value: 'cs', label: ' Czech', symbol: 'CS', title: 'Czech Republic' },
  { value: 'en', label: ' English', symbol: 'EN', title: 'USA' },
  { value: 'es', label: ' Spanish', symbol: 'ES', title: 'Spain' },
  { value: 'pl', label: ' Polish', symbol: 'PL', title: 'Poland' },
  { value: 'da', label: ' Danish', symbol: 'DA', title: 'Denmark' },
]
